import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useNicheNominal(
  nominalId,
  { image = false, addresses = false } = {},
) {
  const queryKey = ['nicheNominal', nominalId, image, addresses];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      try {
        const personId = await platformApi
          .get(`niche/people/id/${nominalId}`, { signal })
          .text();

        const searchParams = new URLSearchParams({
          image,
          addresses,
        });

        return await platformApi
          .get(`niche/people/${personId}`, {
            searchParams,
            signal,
          })
          .json();
      } catch (error) {
        if (error.data?.statusCode === 404) {
          return null;
        } else {
          throw error;
        }
      }
    },
    enabled: !!nominalId,
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
